export const environment = {
  serverUrl: "/api"
};
